import React, {useContext, useState} from 'react';
import theme from '../theme';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

import SupportDisplay from '../components/SupportPaper';
import LoggedInDisplay from '../components/LoggedInPaper';
import BalanceDisplay from '../components/SessionBalancePaper';
import LoginButton from '../components/LoginButton';
import LoginDialog from '../components/LoginDialog';
import ForgottenDialog from '../components/ForgottenDialog';
import RegisterButton from '../components/RegisterButton';
import RegisterDialog from '../components/RegistrationDialog';
import DemoDialog from '../components/DemoDialog';
import LogoutOption from '../components/LogoutDialog';
import AccountOption from '../components/AccountInterface';
import OrderOption from './OrderInterface';

import { SessionContext } from "../context/session-context";
import {useHistory} from "react-router-dom";

//const imglogo = require('../assets/logo.png');
//const imglogo = require('../assets/logo_dataportal.png');
const imglogo = require('../assets/'+process.env.REACT_APP_SITE_LOGO);
const styles = {
  root: {
    flexGrow: 1,
    background: 'white',
    color: 'white',
  },
  buttonContainer: {
    marginLeft: theme.spacing(2),
    alignSelf: 'flex-end',
  },
  menuButton: {
    color: '#273090',
      '&:hover': {
        color: '#F9AF44'
      }
  },
  logo: {
    height: 52
  },
  toolbar: {
    background: 'white',
    height: 67,
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
  },

};


function TopBar(props) {
  const [session] = useContext(SessionContext);
  const {classes, isLogin, isRegister, isForgotten, isDemo} = props;

  const history = useHistory();
  function handleLoginClick(e) {
    e.preventDefault();
    history.push("/login");
  }
  function handleForgottenClick(e) {
    e.preventDefault();
    history.push("/forgotten-password");
  }
  function handleRegisterClick(e) {
    e.preventDefault();
    history.push("/register");
  }
  function handleDemoClick(e) {
    e.preventDefault();
    history.push("/demo");
  }
  function handleDialogClose() {
    history.push("/");
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.toolbar}>
          <Box p={1} flexGrow={1}><img src={imglogo} alt="FIND logo" className={classes.logo} /></Box>
          <Box display="flex" >
            { session.isActive ? <LoggedInDisplay/> : '' }
            { session.isActive ? <AccountOption/> : '' }
            { session.isActive ? <OrderOption/> : '' }
            { session.isActive ? '' : <SupportDisplay /> }
            { session.isActive ? <LogoutOption/> : <><LoginButton onClick={handleLoginClick} /><RegisterButton onClick={handleRegisterClick} /><LoginDialog isLogin={isLogin} onClose={handleDialogClose} /><ForgottenDialog isForgotten={isForgotten} onClose={handleDialogClose} /><RegisterDialog isRegister={isRegister} onClose={handleDialogClose} /><DemoDialog isDemo={isDemo} onClose={handleDialogClose} /></>}
          </Box>
          
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default withStyles(styles)(TopBar);
